export default "__VITE_ASSET__BFs1OOWj__"